import { render, staticRenderFns } from "./VehiclesSearch.vue?vue&type=template&id=c0474362"
import script from "./VehiclesSearch.vue?vue&type=script&lang=js"
export * from "./VehiclesSearch.vue?vue&type=script&lang=js"
import style0 from "./VehiclesSearch.vue?vue&type=style&index=0&id=c0474362&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports